import { changeCurrentDeckApi, getPvpCardProfileApi } from "@/api/pvp-card";
import { PvpCardGameProfile } from "@/api/pvp-card/type";
import { getLevel, getTotalExpToLevel } from "awakening-of-war-shared";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const usePvpCardProfileStore = defineStore("pvp-card-profile", () => {
  const profile = ref(new PvpCardGameProfile());
  const currentDeck = ref(0);
  async function init() {
    const data = await getPvpCardProfileApi();
    profile.value = data;
    currentDeck.value = data.currentCardDeckIndex;
  }

  function isOwned(cardId: number) {
    return profile.value.cardInventory.some((item) => item.cardId === cardId);
  }
  function isEquipped(cardId: number) {
    return profile.value.cardDecks[currentDeck.value]?.cards.includes(cardId);
  }

  function changeCurrentDeck(index: any) {
    currentDeck.value = index;
    changeCurrentDeckApi({ currentDeck: index });
  }
  const playerLevel = computed(() => getLevel(profile.value.exp));
  const playerExp = computed(
    () => profile.value.exp - getTotalExpToLevel(playerLevel.value)
  );
  const playerNextExp = computed(
    () =>
      getTotalExpToLevel(playerLevel.value + 1) -
      getTotalExpToLevel(playerLevel.value)
  );
  const playerPercent = computed(
    () =>
      (playerExp.value /
        (getTotalExpToLevel(playerLevel.value + 1) -
          getTotalExpToLevel(playerLevel.value))) *
      100
  );
  return {
    profile,
    init,
    isOwned,
    currentDeck,
    isEquipped,
    changeCurrentDeck,
    playerLevel,
    playerExp,
    playerNextExp,
    playerPercent,
  };
});
